module.exports = {"500117001":"合阳城街道","500117002":"钓鱼城街道","500117003":"南津街街道","500117004":"盐井街道","500117005":"草街街道","500117006":"云门街道","500117007":"大石街道","500117100":"沙鱼镇","500117101":"官渡镇","500117102":"涞滩镇","500117103":"肖家镇","500117104":"古楼镇","500117105":"三庙镇","500117106":"二郎镇","500117107":"龙凤镇","500117108":"隆兴镇","500117109":"铜溪镇","500117112":"双凤镇","500117113":"狮滩镇","500117114":"清平镇","500117115":"土场镇","500117116":"小沔镇","500117117":"三汇镇","500117118":"香龙镇","500117120":"钱塘镇","500117121":"龙市镇","500117123":"燕窝镇","500117124":"太和镇","500117125":"渭沱镇","500117126":"双槐镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500117.json
// module id = 2357
// module chunks = 0